import { ENV } from '@user-portal/helpers';
import { setupLogger } from '@user-portal/logger';

export const initLogger = () => {
    const clientToken = import.meta.env.DD_RUM_CLIENT_TOKEN;
    const serviceName = import.meta.env.DD_SERVICE_NAME;
    const env = import.meta.env.ENV;

    const missingRequiredEnvVars = [
        ['DD_RUM_CLIENT_TOKEN', clientToken],
        ['DD_SERVICE_NAME', serviceName],
        ['ENV', env],
    ]
        .filter(([, value]) => !value)
        .map(([key]) => key);

    if (missingRequiredEnvVars.length > 0) {
        console.error(
            `Logger initialization skipped. Missing required environment variables: ${missingRequiredEnvVars.join(
                ', '
            )}`
        );

        return;
    }

    setupLogger({
        env: import.meta.env.ENV as ENV,
        dataDog: {
            clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
            serviceName: import.meta.env.DD_SERVICE_NAME,
            version: import.meta.env.RELEASE_DATE,
            sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
        },
    });
};
